import { normalizeRefineParameter } from "../../../helpers/normalizeRefineParameter";
import { getQuery } from "../search/domains/filters/selectors/getAllAppliedRefinements";
import {
  CATEGORY_LINKS_CAP_DEFAULT,
  CATEGORY_LINKS_CAP_REDUCED,
  CATEGORY_LINKS_RELATED_CAT_CAP,
  CATEGORY_LINKS_REDUCED_CAP_CIDS,
} from "./constants";
import { getCategoryId, isFacetedNavPage } from "./selectors";

export const getNormalizedRefineForSeoImportantFacetConfig = (config) => {
  const { refinements } = config;
  const facetQuery = refinements
    .map((refinement) => `${refinement.facetId}:${refinement.facetValueId}`)
    .join("|");

  return normalizeRefineParameter({ refine: facetQuery });
};

const isValidFriendlyName = (name) =>
  Boolean(name) && name !== "N/A" && name !== "null";

const filterValid = (links) =>
  (links || []).filter((l) => l && isValidFriendlyName(l.friendlyName));

export const composeRelatedCategoriesLinks = (state) => {
  if (!state) return [];

  const relatedLinks = state.category?.relatedCategories || [];
  const validRelated = filterValid(relatedLinks);

  return validRelated.slice(0, CATEGORY_LINKS_RELATED_CAT_CAP);
};

export const composeCategoryNavigationLinks = (state) => {
  if (!state) return [];

  const breadcrumbs = state.category?.breadcrumbs || [];
  const childLinks = state.category?.childLinks || [];
  const siblingLinks = state.category?.siblingCategories || [];

  const validChild = filterValid(childLinks);
  const validSibling = filterValid(siblingLinks);

  if (validChild.length === 0 && validSibling.length <= 1) {
    return [];
  }

  const isCapped = (() => {
    if (!Array.isArray(breadcrumbs) || breadcrumbs.length === 0) return false;
    const breadcrumbIds = breadcrumbs
      .map((item) => Number(item?.CategoryId))
      .filter((id) => !isNaN(id) && id !== -1);

    return breadcrumbIds.some((id) =>
      CATEGORY_LINKS_REDUCED_CAP_CIDS.includes(id),
    );
  })();

  const pillCap = isCapped
    ? CATEGORY_LINKS_CAP_REDUCED
    : CATEGORY_LINKS_CAP_DEFAULT;
  const combined = [...validChild, ...validSibling];

  return combined.slice(0, pillCap);
};

export const composeFacetedNavigationLinks = (state) => {
  const catId = getCategoryId(state);
  if (!catId) {
    return [];
  }

  const seoImportantFacets = state.category?.details?.seoImportantFacets || [];
  const { refine } = getQuery(state);

  const normalizedRefine = normalizeRefineParameter({ refine });

  const links = seoImportantFacets.map((facet) => {
    const { title, path } = facet;
    const normalizedQuery =
      getNormalizedRefineForSeoImportantFacetConfig(facet);

    if (isFacetedNavPage(state) && normalizedQuery === normalizedRefine) {
      return null;
    }

    return {
      friendlyName: title,
      linkUrl: `${path}?cid=${catId}&refine=${normalizedQuery}`,
    };
  });

  return links.filter(Boolean);
};
